export default __webpack_public_path__ + "static/media/App.4b1d0dfa.less";